(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/reducer.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/reducer.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames$acco = svs.numbergames.accountSelectorReact.actionTypes,
  FETCH_ACCOUNT_LIST = _svs$numbergames$acco.FETCH_ACCOUNT_LIST,
  SET_ACCOUNT_LIST = _svs$numbergames$acco.SET_ACCOUNT_LIST,
  SET_ACCOUNT = _svs$numbergames$acco.SET_ACCOUNT,
  INIT = _svs$numbergames$acco.INIT;
svs.numbergames.accountSelectorReact.initialState = {
  loading: true,
  selectedAccount: null,
  accounts: null,
  selectedAccountChanged: false
};
svs.numbergames.accountSelectorReact.reducer = (state, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_LIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: true
        });
      }
    case SET_ACCOUNT_LIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          accountList: action.payload
        });
      }
    case INIT:
      {
        return {
          loading: false,
          selectedAccount: action.payload.selectedAccount,
          accountList: action.payload.accounts,
          selectedAccountChanged: Boolean(action.payload.selectedAccountChanged)
        };
      }
    case SET_ACCOUNT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedAccount: action.payload
        });
      }
    default:
  }
  return state;
};

 })(window);